import { render, staticRenderFns } from "./SpecsTable.vue?vue&type=template&id=75cf6f7a&"
import script from "./SpecsTable.vue?vue&type=script&lang=js&"
export * from "./SpecsTable.vue?vue&type=script&lang=js&"
import style0 from "./SpecsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports